<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import AgendaTaskRow from './AgendaTaskRow.vue';

defineProps({
  tasks: { type: Array, default: () => [] },
  hasMore: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  showAssignee: { type: Boolean, default: false },
  resolveTypeName: { type: Function, default: () => '' },
  resolveAssigneeName: { type: Function, default: () => '' },
});
const emit = defineEmits(['edit', 'complete', 'remove', 'loadMore']);
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-2">
    <ul v-if="tasks.length" class="flex flex-col gap-1.5">
      <AgendaTaskRow
        v-for="task in tasks"
        :key="task.id"
        :task="task"
        :type-name="resolveTypeName(task)"
        :assignee-name="resolveAssigneeName(task)"
        :show-assignee="showAssignee"
        @edit="emit('edit', $event)"
        @complete="emit('complete', $event)"
        @remove="emit('remove', $event)"
      />
    </ul>
    <div v-if="hasMore" class="flex justify-center pt-2">
      <Button
        ghost
        slate
        sm
        :label="t('LEADS.AGENDA.LOAD_MORE')"
        :is-loading="isLoading"
        @click="emit('loadMore')"
      />
    </div>
  </div>
</template>
